import { Routes } from '@angular/router';
import { CustomerGuard } from '@next/core-lib/relationships';

import { deviceRedirectGuard } from '../shared/guards/device-redirect.guard';
import { moduleActivationGuard } from '../shared/guards/module-activation.guard';
import { AdviceComponent } from './components/advice/advice.component';

export const virusMonitorRoutes: Routes = [
  {
    path: 'virus-monitor',
    redirectTo: 'virus-monitor',
  },
  {
    path: 'virus-monitor',
    component: AdviceComponent,
    canActivate: [CustomerGuard, deviceRedirectGuard, moduleActivationGuard('virus-monitor')],
  },
];
